module.exports = __webpack_public_path__ + "img/tips.a072a884.png";